export * from './create-middleware';
export * from './file-uploader';

// OLD
export * from './component-decorator';
export * from './dynamic-sref';
export function createAsyncAction(prefix) {
    return {
        REQUEST: `${prefix}_REQUEST`,
        SUCCESS: `${prefix}_SUCCESS`,
        FAIL: `${prefix}_FAIL`
    };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/utils/index.ts